// extracted by mini-css-extract-plugin
export default {"fileSelectInput":"FileSelect_fileSelectInput__9STkK"};